import { connect } from 'react-redux'
import * as action from '../../state/search/action'
import * as selector from '../../state/search/selector'
import AppointmentSearch from './AppointmentSearch'
import { push } from 'connected-react-router'
import { selectIsTablet } from '../../../layout/state/selector'


const mapStateToProps = state => {
    return {
        tableData: selector.selectTable(state),
        isTablet: selectIsTablet(state),
    }
}

const mapDispatchToProps = {
    initialTableQuery: action.initialTableQuery,
    changeFilter: action.changeFilter,
    toggleSort: action.toggleSort,
    toggleMultiSort: action.toggleMultiSort,
    gotoPage: action.gotoPage,
    initialColumnsVisibility: action.initialTableSettings,
    toggleColumnVisibility: action.toggleColumnVisibility,
    navigateToAppointment: (appointmentId) => {
        return push('/appointment/edit/' + appointmentId)
    },
}


export default connect(mapStateToProps, mapDispatchToProps)(AppointmentSearch)



// WEBPACK FOOTER //
// ./src/modules/appointment/component/search/AppointmentSearchContainer.js